import PlurallClient from '@plurall/client'
import { getToken } from './token'

const plurallClient = apiMenuUrl => {
  const authToken = getToken()

  return new PlurallClient({
    apiURL: apiMenuUrl ? apiMenuUrl : process.env.REACT_APP_PLURALL_API_URL,
    graphqlURL: process.env.REACT_APP_SOMOS_GRAPHQL_URL,
    applicationId: process.env.REACT_APP_ID_APPLICATION,
    accessToken: authToken,
    pmVersion: 2,
  })
}

const apiRedirectUrl = () => {
  const { hostname, protocol } = new URL(process.env.REACT_APP_PLURALL_API_URL)
  return `${protocol}//${hostname}`
}

export { apiRedirectUrl, plurallClient }
